/**
 * Catálogo de códigos de problemas de conexão.
 *
 * Usado na telemetria (New Relic / GA / Clarity) e, futuramente, nas mensagens
 * exibidas ao usuário — o mesmo código que aparece na tela é o que o suporte
 * busca nos painéis.
 *
 * `event` é o nome do evento enviado ao GA/Clarity/New Relic (snake_case,
 * <= 40 caracteres, exigência do GA4).
 */
export const NETWORK_ISSUES = {
  OFFLINE: {
    code: 'NET-001',
    event: 'network_error',
    type: 'offline',
    description: 'Requisição falhou com o dispositivo sem conexão'
  },
  TIMEOUT: {
    code: 'NET-002',
    event: 'network_error',
    type: 'timeout',
    description: 'Requisição excedeu o tempo limite'
  },
  NETWORK_FAILURE: {
    code: 'NET-003',
    event: 'network_error',
    type: 'network_failure',
    description: 'Requisição falhou sem resposta do servidor (conexão instável, DNS, CORS)'
  },
  SLOW_RESPONSE: {
    code: 'NET-004',
    event: 'network_slow',
    type: 'slow_response',
    description: 'Requisição concluída, mas acima do limite de lentidão'
  },
  ASSET_LOAD_FAILED: {
    code: 'NET-005',
    event: 'asset_load_failed',
    type: 'asset_load_failed',
    description: 'Falha ao baixar script/estilo do app'
  },
  BOOT_FAILED: {
    code: 'NET-006',
    event: 'app_boot_failed',
    type: 'boot_failed',
    description: 'Falha ao carregar configuração do tenant na abertura do app'
  },
  OFFLINE_PERIOD: {
    code: 'NET-007',
    event: 'network_offline_period',
    type: 'offline_period',
    description: 'Dispositivo ficou offline por um período (enviado ao reconectar)'
  },
  DEGRADED: {
    code: 'NET-008',
    event: 'network_degraded',
    type: 'degraded',
    description: 'Navegador detectou conexão muito lenta (2G/slow-2G)'
  }
};
